export const ONLY_NUMBERS_REGEX = /^\d+$/;

export enum AllowedFileType {
  JPEG = 'image/jpeg',
  JPG = 'image/jpg',
  PNG = 'image/png',
  PDF = 'application/pdf'
}

export const BGV_PREFIX = 'bgv-';

export const DEFAULT_ORG = 'TRENTIAL';
export const NSDC_ORG = 'NSDC';
export const WES_ORG = 'WES';
export const CES_ORG = 'CES';

export const CLIENT_FLOWS = {
  CM: 'CM'
};
